import { render, staticRenderFns } from "./subPoint.vue?vue&type=template&id=56af90f4&scoped=true&"
import script from "./subPoint.vue?vue&type=script&lang=js&"
export * from "./subPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56af90f4",
  null
  
)

export default component.exports